import { Box, Card as MUICard, styled } from '@mui/material'

export const Card = styled(MUICard)<{ touchable?: boolean; draggable?: boolean }>`
  box-shadow: 0px 3px 6px #00000029;
  border: 2px solid #d9e1e7;
  border-radius: 4px;
  cursor: ${props => (props.draggable ? 'grab' : props.touchable ? 'pointer' : 'default')};
`

export const StyledDetailCard = styled(Card)<{ ismodal?: boolean; elevation: number }>(
  ({ theme, ismodal = false, elevation = 1 }) => ({
    border: ismodal ? 'none' : `1px solid ${theme.palette.secondaryLight[theme.palette.mode]}`,
    boxShadow: ismodal
      ? 'none'
      : `0px ${elevation * 3}px ${elevation * 6}px ${theme.palette.black[theme.palette.mode]}29`,
  }),
)

export const ContainerBox = styled(Box)`
  border: ${props => `1px solid ${props.theme.palette.secondaryLight[props.theme.palette.mode]}`};
  width: 100%;
  padding: 8px;
`
